import httpClient from '@/modules/cart/services/api/client';
import environment from '@/modules/perseo-billing/environments/environment';
import type { IAvailablePaymentMethodsResponse } from '@/modules/perseo-billing/interfaces';
import type { IApiResponse } from '@/modules/perseo-billing/interfaces/src/bff-web/billing';
import type {
  IOrder,
  IOrderIntentStateResponse
} from '@/modules/perseo-billing/interfaces/src/bff-web/billing/interfaces/orderV2';
import {
  getWeddingID,
  isWeddingFlow
} from '@/modules/shared/utils/isWeddingFlow';

const {
  AVAILABLE_PAYMENTS_URL,
  GET_ORDER_ID,
  CONFIRM_ORDER_INTENT,
  CONFIRM_WEDDING_ORDER_INTENT
} = environment;

const DEFAULT_CONFIG = {
  timeout: 10000
};

export async function getAvailablePayments(
  platform: string
): Promise<IAvailablePaymentMethodsResponse> {
  const response = await httpClient.get<
    IApiResponse<IAvailablePaymentMethodsResponse>
  >(AVAILABLE_PAYMENTS_URL + '?platform=' + platform);
  return response.data.data;
}

export async function getBillingOrderStatus({
  orderNumber
}: {
  orderNumber: string | null;
}): Promise<IOrderIntentStateResponse> {
  const isWedding = isWeddingFlow();
  const weddingId = getWeddingID();

  if (isWedding) {
    const confirmUrl = `${CONFIRM_WEDDING_ORDER_INTENT}/${orderNumber}`;
    const url = confirmUrl.replace(':idWedding', weddingId);
    return await httpClient.get(url, DEFAULT_CONFIG);
  }

  const url = `${CONFIRM_ORDER_INTENT}/${orderNumber}`;
  const response = await httpClient.get(url, DEFAULT_CONFIG);

  return Promise.resolve(response.data);
}

export async function getBillingOrderId({
  orderId
}: {
  orderId: string | null;
}): Promise<IOrder> {
  const url = `${GET_ORDER_ID}/${orderId}`;
  const response = await httpClient.get(url, DEFAULT_CONFIG);

  return Promise.resolve(response.data);
}
